import { cache } from 'react';
import type { NativeApiResponse, NativeAppStructure } from '@/types/aggregation/native-app-data';
import { buildUrl } from '@/utils/url/build-url';
import { getParams } from './aggregation';
import { fetchApi } from './fetcher';

const isNativeApiError = (value: unknown): value is { error: string } =>
    typeof value === 'object' && value !== null && 'error' in value && typeof value.error === 'string';

const fetchNativeAppStructure = async (currentRoute: string): Promise<NativeAppStructure | null> => {
    const { host, headers, params, networkConfig } = await getParams(currentRoute);
    const { url: _, ...baseParams } = params;
    const response = await fetchApi(
        buildUrl(host, {
            ...baseParams,
            data: 'native-api',
            urn: `ppb:gaming:${baseParams.product}:appStructure`,
            url: currentRoute,
            extended: 'true'
        }),
        { method: 'GET', headers },
        { networkConfig }
    );
    const payload = (await response.json()) as NativeApiResponse<NativeAppStructure>;
    const responseData = payload.response;

    if (!responseData || isNativeApiError(responseData)) {
        return null;
    }

    return {
        ...responseData,
        region_info: payload.regionInfo ?? responseData.region_info,
        experiments: payload.experiments ?? responseData.experiments
    };
};

export const getNativeAppStructure = cache(
    async (currentRoute: string): Promise<NativeAppStructure | null> => fetchNativeAppStructure(currentRoute)
);
